import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const DeleteStudentEnrollmentMutation = graphql.persisted(
  "DeleteStudentEnrollment",
  graphql(`
    mutation DeleteStudentEnrollment($studentEnrollmentId: ID!) {
      deleteStudentEnrollment(input: {studentEnrollmentId: $studentEnrollmentId}) {
        success
        deletedFamilyEnrollment
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { DeleteStudentEnrollmentMutation };

export function useDeleteStudentEnrollment() {
  return useMutation(DeleteStudentEnrollmentMutation);
}
